namespace $ { $mol_style_attach( "mol/pick/pick.view.css",
 "[mol_pick_trigger] {\n\talign-items: center;\n\tflex-grow: 1;\n}\n"
) }